import { Button, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import { useState } from 'react';
import { DatePicker } from '@mui/x-date-pickers';

type Props = {
  reSchedulingTaskDate: any;
  handleSelectDate: any;
  setReSchedulingTask: any;
};

const isPastDate = (reSchedulingDate: any) => {
  if (!reSchedulingDate) return false;
  const todayDate = new Date();
  todayDate.setHours(0, 0, 0, 0);
  const schedulingDate = new Date(reSchedulingDate);
  schedulingDate.setHours(0, 0, 0, 0);
  if (schedulingDate === todayDate) return false;
  if (schedulingDate < todayDate) return true;
  else return false;
};

function RescheduleTaskModal(props: Props) {
  const { reSchedulingTaskDate, handleSelectDate, setReSchedulingTask } = props;
  const [getDate, setDate] = useState(reSchedulingTaskDate);

  return (
    <Grid
      width={600}
      container
      flexDirection={'column'}
      gap={'20px'}
    >
      <DialogTitle
        sx={{ m: 0, p: 2 }}
        id="customized-dialog-title"
      >
        <Typography variant="h6">Reschedule The Task</Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          paddingBottom: '0px !important',
        }}
      >
        <DatePicker
          onChange={(newDate) => setDate(newDate)}
          label="Task Date"
          value={getDate}
          format="MM dd, yyyy"
          disablePast
          sx={{
            width: '100%',
            border: '2px solid #6366F1',
            borderRadius: '10px',
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={() => setReSchedulingTask(false)}
        >
          Cancel
        </Button>
        <Button
          autoFocus
          variant="contained"
          disabled={isPastDate(getDate)}
          type="submit"
          onClick={() => handleSelectDate(getDate)}
        >
          Reschedule
        </Button>
      </DialogActions>
    </Grid>
  );
}

export default RescheduleTaskModal;
